import React from 'react'
import { FormControl, InputLabel } from '@mui/material'
import { ChevronDownMD } from '../Icon'
import ErrorMessage from '../error-message'
import { MenuItem, Select as MuiSelect } from './styles'
import type { SelectProps } from './types'

const Select: React.FC<SelectProps> = ({
  label,
  value,
  onChange,
  options,
  fullWidth = true,
  error,
  disabled = false,
  testId,
}) => (
  <ErrorMessage hasError={Boolean(error)} errorMessage={error}>
    <FormControl fullWidth={fullWidth} error={Boolean(error)} disabled={disabled}>
      <InputLabel color="secondary">{label}</InputLabel>
      <MuiSelect
        data-testid={testId}
        value={value}
        onChange={(e) => onChange(e.target.value as string | null)}
        IconComponent={ChevronDownMD}
        label={label}
        color="secondary"
      >
        {options.map(({ value: optionValue, label: optionLabel, id }) => (
          <MenuItem key={id} value={optionValue} data-testid={`${testId ?? 'select'}-${optionValue}`}>
            {optionLabel}
          </MenuItem>
        ))}
      </MuiSelect>
    </FormControl>
  </ErrorMessage>
)

export default Select
